<form 
    (ngSubmit)="$event.preventDefault(); saveCodeOfConduct();"
    [formGroup]="codeOfConductForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Code of Conduct
        </h2>
        <div class="w-full flex flex-col items-center gap-2 pb-4">
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Disciplinary action has been, will be, or needs to be taken.</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="code_of_conduct_yes" [value]="yesNo.Yes" class="hidden peer"
                                formControlName="code_of_conduct">
                        <label for="code_of_conduct_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="code_of_conduct_no" [value]="yesNo.No" class="hidden peer"
                                formControlName="code_of_conduct">
                        <label for="code_of_conduct_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No
                        </label>
                    </div>
                </div>            
            </div>

            <div *ngIf="codeOfConductForm.get('code_of_conduct')?.value == yesNo.Yes" class="w-full flex flex-col items-start text-start">
                <div class="w-full flex flex-col items-start text-start gap-2">
                    <div class="w-full font-semibold">
                        <p>Disciplinary action has already been taken. *</p>
                    </div>
                    <div class="w-full flex items-start gap-2">
                        <div>
                            <input type="radio" id="disciplinary_action_taken_yes" [value]="yesNo.Yes" class="hidden peer"
                                    formControlName="disciplinary_action_taken">
                            <label for="disciplinary_action_taken_yes"
                                    class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                Yes
                            </label>
                        </div>
                        <div>
                            <input type="radio" id="disciplinary_action_taken_no" [value]="yesNo.No" class="hidden peer"
                                    formControlName="disciplinary_action_taken">
                            <label for="disciplinary_action_taken_no"
                                    class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                No
                            </label>
                        </div>
                    </div>   
                    

                    <div *ngIf="codeOfConductForm.get('disciplinary_action_taken')?.value == yesNo.No" class="w-full flex flex-col items-center text-start">
                        <div class="w-full font-semibold">
                            <p>Planning Notes: *</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea formControlName="disciplinary_action_taken_notes"
                                        rows="3"
                                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                        placeholder="Explain..."></textarea>
                        </div>
                    </div>

                    <div *ngIf="codeOfConductForm.get('disciplinary_action_taken')?.value == yesNo.Yes" class="w-full flex flex-col items-center text-start">
                        <div class="w-full font-semibold">
                            <p>Please describe the action taken (i.e. suspension, expulsion, other) *</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea formControlName="action_taken"
                                        rows="3"
                                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                        placeholder="Explain..."></textarea>
                        </div>
                    </div>
                    <div *ngIf="codeOfConductForm.get('disciplinary_action_taken')?.value == yesNo.Yes" class="w-full flex flex-col items-start text-start gap-2">
                        <div class="w-full flex flex-col items-start text-start gap-2">
                            <div class="w-full font-semibold">
                                <p>Out-of-School Suspension? *</p>
                            </div>
                            <div class="w-full flex items-start gap-2">
                                <div>
                                    <input type="radio" id="suspension_yes" [value]="yesNo.Yes" class="hidden peer"
                                            formControlName="suspension">
                                    <label for="suspension_yes"
                                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                        Yes
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="suspension_no" [value]="yesNo.No" class="hidden peer"
                                            formControlName="suspension">
                                    <label for="suspension_no"
                                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                        No
                                    </label>
                                </div>
                            </div>  
                        </div>    
                    
                        <div *ngIf="codeOfConductForm.get('suspension')?.value == yesNo.Yes" class="w-full flex flex-col items-center text-start">
                            <div class="w-full font-semibold">
                                <p>Out-of-School Suspension Return Date: *</p>
                            </div>
                            <div class="w-full flex items-center gap-2">
                                <div class="relative">
                                    <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                        <svg class="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                        </svg>
                                    </div>
                                    <input id="datepicker-suspension-return-date" #datepickerSuspensionReturnDate name="suspension_return_date" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2">
                                </div>
                            </div>
                        </div> 
                        <div *ngIf="codeOfConductForm.get('disciplinary_action_taken')?.value == yesNo.Yes" class="w-full flex flex-col items-start text-start">
                            <div class="w-full font-semibold">
                                <p>One or more ROAR assignments will be needed for this determination. *</p>
                            </div>
                            <div class="w-full flex items-start gap-2">
                                <div>
                                    <input type="radio" id="action_roar_assignments_yes" [value]="yesNo.Yes" class="hidden peer"
                                            formControlName="action_roar_assignments">
                                    <label for="action_roar_assignments_yes"
                                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                        Yes
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="action_roar_assignments_no" [value]="yesNo.No" class="hidden peer"
                                            formControlName="action_roar_assignments">
                                    <label for="action_roar_assignments_no"
                                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                        No
                                    </label>
                                </div>
                            </div>            
                        </div>  
                        <div *ngIf="codeOfConductForm.get('action_roar_assignments')?.value == yesNo.Yes" class="w-full flex flex-col items-center text-start">
                            <div class="w-full font-semibold">
                                <p>Planning Notes: *</p>
                            </div>
                            <div class="w-full flex flex-col items-center">
                                <textarea formControlName="roar_assignments_planning_notes"
                                            rows="3"
                                            class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                            placeholder="Explain..."></textarea>
                            </div>
                        </div>     
                    </div>
                </div>    
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.codeOfConductForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.codeOfConductForm.valid
                }"
            >
                Save
            </button>
        </div>
    </div>
</form>